import { FilterLogRequest } from '../model/log-filter-request.model';
import { Log } from '../model/log.model';
import { LogService } from '../service/log.service';
import { setPageNumber, setPageSize, withPagination, withPaginationMethods } from '@shared/state/pagination.feature';
import { updateState, withDevtools, withFeatureFactory } from '@angular-architects/ngrx-toolkit';
import { computed, inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { setError, setFulfilled, setPending, withRequestStatus } from '@shared/state/request-status.feature';
import { pipe, switchMap, tap } from 'rxjs';

export const LogStore = signalStore(
  withDevtools('activity-log'),
  withState({
    data: null as Log[] | null,
  }),
  withRequestStatus(),
  withFeatureFactory((store) => withPagination<Log>(store.data)),
  withComputed(({ data }) => ({
    logs: computed(() => data()),
  })),
  withMethods((store, logService = inject(LogService)) => ({
    load: rxMethod<FilterLogRequest>(
      pipe(
        tap(({ pageNumber, pageSize, enableGlobalLoader }) => {
          if (!enableGlobalLoader) {
            updateState(store, '[LogStore] Set pending', setPending());
          }
          updateState(store, '[LogStore] Set page number', setPageNumber(pageNumber));
          updateState(store, '[LogStore] Set page size', setPageSize(pageSize));
        }),
        switchMap(({ search, enableGlobalLoader }) =>
          logService
            .getLogs({ search, pageSize: store.pageSize(), pageNumber: store.pageNumber(), enableGlobalLoader })
            .pipe(
              tapResponse({
                next: (data) => {
                  updateState(store, '[LogStore] Set fulfilled', setFulfilled());
                  updateState(store, '[LogStore] Set data', { data });
                },
                error: () => {
                  updateState(store, '[LogStore] Set error', setError());
                  updateState(store, '[LogStore] Set data', { data: null });
                },
              }),
            ),
        ),
      ),
    ),
  })),
  withFeatureFactory((store) => withPaginationMethods(store)),
);
